import {
  BookMarkParams,
  CustomAxiosType,
  CustomAxiosSingleType,
  LesseeDetail,
} from "./../types/types";
import { client } from "./client";

const b6t = `NB6T`;

export interface BookMark {
  idx?: number;
  admin_idx: number;
  address: string;
  name: string;
  latitude: number;
  longitude: number;
  registered_at?: string;
  unique_idx: string;
}

// 즐겨찾기 조회
export const getBookMark = async ({ admin_idx }: BookMarkParams) => {
  const response = await client.post<CustomAxiosType<BookMark[]>>(
    `/api/bookmark` + b6t + `/get`,
    {
      admin_idx,
    }
  );
  return response.data.result;
};

// 즐겨찾기 등록
export const postBookMark = async ({
  idx,
  admin_idx,
  address,
  name,
  latitude,
  longitude,
  unique_idx,
}: BookMark) => {
  const response = await client.post<CustomAxiosSingleType>(
    `/api/bookmark` + b6t,
    {
      idx,
      admin_idx,
      address,
      name,
      latitude,
      longitude,
      unique_idx,
    }
  );
  return response.data;
};

// 즐겨찾기 삭제
export const deleteBookMark = async (idx: number) => {
  const response = await client.post<CustomAxiosSingleType>(
    `/api/bookmark` + b6t + `/delete`,
    {
      idx: idx,
    }
  );
  return response.data;
};

// 임차인 정보 조회
export const getLesseeDetail = async ({
  device_pid,
}: {
  device_pid: string;
}) => {
  const response = await client.post<CustomAxiosType<LesseeDetail>>(
    `/api/lessee`,
    {
      device_pid,
    }
  );
  return response.data;
};
